import luBatchInput from "./src/lu-batch-input";

luBatchInput.install = function(Vue) {
  Vue.component(luBatchInput.name, luBatchInput);
};

export default luBatchInput;
